/**
 * As graph & analytics panel are still not part of react and uses old ejs code
 * we need to emit events to update the graph.
 * So these are modules responsible executing side effects on any filter change.
 *
 * NOTE:
 * highlighting based on the node intersection:
 * eg tag & topics:  filter statements  by tag & filter statement by topic
 *          --> extract nodes contain in both: then take intersection between the set containing nodes
 *          so we highlight nodes that appearing in both set of nodes
 */
import { hasActiveFilters } from '../StatementFilterPanel/filterStatements'

export const handleCombinedHighlightFilters = (
    newFilters,
    prevFilters,
    filteredStatements
) => {
    const activeFilters = {
        topics: newFilters.topics.length > 0,
        sentiments: newFilters.sentiments.length > 0,
        tags: newFilters.tags.length > 0,
    }
    const isAnyFilterActive = hasActiveFilters(newFilters)
    const allNodes = graphFactory.getNodeNames()

    const topicsChanged = !arraysAreEqual(newFilters.topics, prevFilters.topics)

    let selectedNodes = []

    let selectedNodesBySentiment = []
    let selectedNodesByTag = []
    let selectedNodesByTopic = []

    if (!isAnyFilterActive) {
        emitEvent('selectNodes', allNodes)
        return
    }

    if (activeFilters.sentiments) {
        const sentimentStatements = getSentimentStatements(
            newFilters.sentiments,
            filteredStatements
        )
        selectedNodesBySentiment = extractHashtagsFromStatements(
            sentimentStatements
        )
    }

    if (activeFilters.tags) {
        const filterOverlapMode = newFilters.overlapMode
        const tagNodes = getTagStatements(
            newFilters.tags,
            filterOverlapMode,
            filteredStatements
        )
        selectedNodesByTag = extractHashtagsFromStatements(tagNodes)
    }

    if (activeFilters.topics) {
        selectedNodesByTopic = newFilters.topics
            .flatMap(topic => {
                return topic.nodes
            })
            .map(node => node.name)
        selectedNodes = [...selectedNodes, ...selectedNodesByTopic]
    }
    if (topicsChanged) {
        const newTopicIds = newFilters.topics.map(({ id }) => id.toString())
        emitEvent('selectCommunity', newTopicIds)
    }

    const filterResults = [
        selectedNodesBySentiment,
        selectedNodesByTag,
        selectedNodesByTopic,
    ]
    const activeNodes = filterResults.filter(arr => arr.length > 0)
    const filteredNodes = intersectArrays(activeNodes)

    // Emit event with all selected nodes/hashtags
    emitEvent('selectNodes', filteredNodes)
}

// Event emitter utility functions
const emitEvent = (eventName, data) => {
    if (window.myEventEmitter && myEventEmitter._events[eventName]) {
        myEventEmitter.emit(eventName, data)
    }
}

// Helper functions for data processing
const extractHashtagsFromStatements = statements => {
    return statements.flatMap(statement => statement.hashtags).filter(Boolean)
}

const getSentimentStatements = (sentiments, filteredStatements) => {
    return filteredStatements.filter(statement =>
        sentiments.includes(statement.sentiment)
    )
}

const getTagStatements = (tags, filterOverlapMode, filteredStatements) => {
    const tagStatements = filteredStatements.filter(statement =>
        filterOverlapMode
            ? tags.every(tag => statement.tags.includes(tag))
            : tags.some(tag => statement.tags.includes(tag))
    )

    return tagStatements
}
const arraysAreEqual = (arr1, arr2) => {
    if (arr1.length !== arr2.length) return false
    const sortedArr1 = [...arr1].sort()
    const sortedArr2 = [...arr2].sort()
    return sortedArr1.every((value, index) => value === sortedArr2[index])
}

function intersectArrays(arrays) {
    if (arrays.length === 0) return []
    // Start with the first array, then filter down
    return arrays.reduce((acc, curr) => acc.filter(x => curr.includes(x)))
}
